import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import logo from "../../images/fractal-logo.png";
import ErrorMessage from "../ErrorMessage";
import UsernameForm from "./UsernameForm";
import PasswordForm from "./PasswordForm";

// Login page, where users can authenticate into the system.
function LoginForm() {

    // Redirect the user to the Explore page if they are already logged in
    const user = useCurrentUser();

    // Redirection logic
    const navigate = useNavigate();
    const redirectToExplore = () => {
        navigate("/explore");
    }

    if (user) {
        redirectToExplore();
    }

    // Error object, containing error state and error message
    const [error, setError] = useState({ "error": false, "error-msg": "" });

    // String that holds username, once validated; passed between username & password forms
    const [validatedUsername, setValidatedUsername] = useState("");

    return (
        <div id='login-container'>
            <div id='login-panel'>
                <div id='login-greeting'>
                    <div id='logo-tagline'>
                        <img src={logo} id='login-logo' alt="" /> {/* Leave alt text empty; decorative */}
                        <h3>Learning computer science through art.</h3>
                    </div>
                </div>
                <div id='login-form'>
                    {/* Responsive logo is only displayed at screen widths of 480px, since #login-greeting disappears */}
                    <img src={logo} id='responsive-logo' alt="" /> {/* Leave alt text empty; decorative */}
                    {/* Login form itself */}
                    <h3 className="center-text">Welcome Back!</h3>
                    {validatedUsername === "" ? (
                        <UsernameForm redirectToExplore={redirectToExplore} setError={setError} setValidatedUsername={setValidatedUsername} />
                    ) : (
                        <PasswordForm redirectToExplore={redirectToExplore} setError={setError} validatedUsername={validatedUsername} />
                    )}
                    {/* Error badge that appears if there is an error during the login process */}
                    {error["error"] ? (
                        <ErrorMessage errorMessage={error["error-msg"]} />
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default LoginForm;
